import React from 'react';
import {makeStyles} from 'tss-react/mui';
import {createTheme, ThemeProvider} from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import CardMui from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

const theme = createTheme();
const useStyles = makeStyles()({
   root: {
      minWidth: 275
   }
});

function Card(props) {
   const {classes, cx} = useStyles();
   const {registro, children, className, xs, ...other} = props;
   return (
      <Grid container item xs={xs || 3} {...other}>
         <CardMui className={cx(classes.root, className)}>
            <CardContent>
               <Grid container item xs={12}>
                  {children}
               </Grid>
            </CardContent>
         </CardMui>
      </Grid>
   );
}

export default Card;
